import {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css} from "@panda/css";

import {Col, Container, Row} from "@pg-design/grid-module";

import {IRPStore} from "../../app/rp_reducer";
import {offerBoxTracking} from "../../offer/tracking/offer_box_gtm_events";
import {offerPlural} from "../../offer/utils/offer_plural";
import {fetchHomepageOfferList, resetHomepageOfferList} from "../actions/fetch_homepage_offer_list";
import {sortDefaultOption, sortOptions, SortValue} from "../constants/offer_list";
import {regionDefaultOptionValue} from "../hooks/use_homepage_region_options";
import {getMoreOffersLink} from "../utils/get_more_offers_link";
import {IRegionOption, OffersPanel} from "./OffersPanel/OffersPanel";

export const HomepageRecommendedOffers = () => {
    const dispatch = useDispatch();

    const recommendedOffersCount = useSelector((state: IRPStore) => state.homepage.count);

    const [sortValue, setSortValue] = useState(sortDefaultOption.value);
    const currentSortOption = useMemo(() => sortOptions.find((el) => el.value === sortValue), [sortValue]);

    useEffect(() => {
        dispatch(fetchHomepageOfferList({region: regionDefaultOptionValue, sort: sortDefaultOption.value}));
    }, []);

    const onFiltersChange = (region: IRegionOption, sort: string) => {
        dispatch(resetHomepageOfferList());

        const query: {[key: string]: number | string} = {region: region.value, sort};

        if (sort === SortValue.PROMOTED) {
            query.with_promotions = "True";
        }

        dispatch(fetchHomepageOfferList(query));

        setSortValue(sort as SortValue);
    };

    const moreOffersCountText = recommendedOffersCount ? `Zobacz jeszcze ${recommendedOffersCount} ${offerPlural(recommendedOffersCount)}` : "";

    return (
        <Container as="section" className={sectionWrapper}>
            <Row>
                <Col className={col}>
                    <OffersPanel
                        getMoreOffersLink={(regionValue: IRegionOption, sortValue: string) => getMoreOffersLink(regionValue, sortValue)}
                        moreOffersText={sortValue === SortValue.RATING ? "Zobacz więcej" : moreOffersCountText}
                        onChange={onFiltersChange}
                        sortInitialValue={sortDefaultOption.value}
                        sortOptions={sortOptions}
                        listId="polecane_oferty"
                        listTitle={`Polecane oferty - ${currentSortOption?.title}`}
                        gtmTileEvents={{
                            imageClick: offerBoxTracking.gtm.investAdditionalImageClick,
                            buttonClick: offerBoxTracking.gtm.investAdditionalButtonClick,
                            linkClick: offerBoxTracking.gtm.investAdditionalLinkClick,
                            logoClick: offerBoxTracking.gtm.investAdditionalLogoClick
                        }}
                    />
                </Col>
            </Row>
        </Container>
    );
};

export const sectionWrapper = css({
    marginTop: 6,
    overflow: "hidden"
});

const col = css({
    padding: 0,

    md: {
        paddingX: 3
    }
});
import {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css} from "@panda/css";

import {Col, Container, Row} from "@pg-design/grid-module";

import {IRPStore} from "../../app/rp_reducer";
import {offerBoxTracking} from "../../offer/tracking/offer_box_gtm_events";
import {offerPlural} from "../../offer/utils/offer_plural";
import {fetchHomepageOfferList, resetHomepageOfferList} from "../actions/fetch_homepage_offer_list";
import {sortDefaultOption, sortOptions, SortValue} from "../constants/offer_list";
import {regionDefaultOptionValue} from "../hooks/use_homepage_region_options";
import {getMoreOffersLink} from "../utils/get_more_offers_link";
import {IRegionOption, OffersPanel} from "./OffersPanel/OffersPanel";

export const HomepageRecommendedOffers = () => {
    const dispatch = useDispatch();

    const recommendedOffersCount = useSelector((state: IRPStore) => state.homepage.count);

    const [sortValue, setSortValue] = useState(sortDefaultOption.value);
    const currentSortOption = useMemo(() => sortOptions.find((el) => el.value === sortValue), [sortValue]);

    useEffect(() => {
        dispatch(fetchHomepageOfferList({region: regionDefaultOptionValue, sort: sortDefaultOption.value}));
    }, []);

    const onFiltersChange = (region: IRegionOption, sort: string) => {
        dispatch(resetHomepageOfferList());

        const query: {[key: string]: number | string} = {region: region.value, sort};

        if (sort === SortValue.PROMOTED) {
            query.with_promotions = "True";
        }

        dispatch(fetchHomepageOfferList(query));

        setSortValue(sort as SortValue);
    };

    const moreOffersCountText = recommendedOffersCount ? `Zobacz jeszcze ${recommendedOffersCount} ${offerPlural(recommendedOffersCount)}` : "";

    return (
        <Container as="section" className={sectionWrapper}>
            <Row>
                <Col className={col}>
                    <OffersPanel
                        getMoreOffersLink={(regionValue: IRegionOption, sortValue: string) => getMoreOffersLink(regionValue, sortValue)}
                        moreOffersText={sortValue === SortValue.RATING ? "Zobacz więcej" : moreOffersCountText}
                        onChange={onFiltersChange}
                        sortInitialValue={sortDefaultOption.value}
                        sortOptions={sortOptions}
                        listId="polecane_oferty"
                        listTitle={`Polecane oferty - ${currentSortOption?.title}`}
                        gtmTileEvents={{
                            imageClick: offerBoxTracking.gtm.investAdditionalImageClick,
                            buttonClick: offerBoxTracking.gtm.investAdditionalButtonClick,
                            linkClick: offerBoxTracking.gtm.investAdditionalLinkClick,
                            logoClick: offerBoxTracking.gtm.investAdditionalLogoClick
                        }}
                    />
                </Col>
            </Row>
        </Container>
    );
};

export const sectionWrapper = css({
    marginTop: 6,
    overflow: "hidden"
});

const col = css({
    padding: 0,

    md: {
        paddingX: 3
    }
});
